import React, { useEffect, useState } from 'react';
import OxygenOTPComponent from '../components/OxygenOTPComponent';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {sendAODF2NOKOTP, sendNokOtp, validateAODF2NOKOTP, validateNokOtp} from "../services/oxygenRetailServices";
import useCustomAlert from "../components/Alert2";
import { updatePrecustomer } from "../redux/features/precustomers/PrecustomerSlice";
import {bookLoan} from "../services/oxygenRetailServices";
import {setShowModal, hideModal} from "../redux/features/oxygen/customModalSlice";
import {setBookloanLoading, setOtpLoading} from "../redux/features/oxygen/oxygenRetailSlice";
import { updateCustomerOnboardingStat } from '../services/PrequalificationService';

const NextOfKinOTP = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customAlert = useCustomAlert();
    const [otpValidated, setOtpValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const storePrecustomer = useSelector(
      (state) => state?.precustomer?.precustomerData
    );
    const customerDetails = useSelector((state) => state.oxygenRetail?.bookloanDetails);

    const savedOxygenFinancier = localStorage.getItem("allAboard-financierid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-financierid"));
    const financierName = localStorage.getItem("financierName") !== "undefined" && JSON.parse(localStorage.getItem("financierName"));
    const partnerId = localStorage.getItem("allAboard-partnerid") !== "undefined" && JSON.parse(localStorage.getItem("allAboard-partnerid"));
    // for oxygen book loan:
      const oxygenBookLoan = async() => {
        setLoading(true);
        dispatch(setBookloanLoading(true));
        const payload = {
          PreCustomerId:storePrecustomer.precustomer?.precustomerId
        }
        
        const res = await bookLoan(payload);
    
        if(res?.status === true){
          setLoading(false);
          dispatch(setBookloanLoading(false));
          dispatch(hideModal());
          customAlert.showToast("success", `${res?.message}` || "Loan booked successfully");
          navigate("/oxygenLoan-OTP");
        }else{
          setLoading(false);
          dispatch(setBookloanLoading(false));
          customAlert.showToast("error", `${res?.message}` || "Failed to book loan");
        }
      }
    
      // the modal to book oxygenloan
      useEffect(() => {
        if ((savedOxygenFinancier === 14 || Number(partnerId) === 408 || financierName === "Oxygen") && otpValidated) {
          dispatch(setShowModal({
            status:true,
            title:"Book Loan",
            type:"bookLoan",
            showCloseButton:false,
            data:{oxygenBookLoan, loading},
          }));
        }
      }, [savedOxygenFinancier, financierName, partnerId, otpValidated, dispatch]);

    const handleResendNOKOTP = async() =>{
      const payload ={
        msisdn:storePrecustomer.precustomer?.msisdn ,
        preCustomerId:storePrecustomer.precustomer?.precustomerId
      }

      let res;
      if(Number(savedOxygenFinancier === 14 )){
        res = await sendNokOtp(payload);
      }else if(Number(savedOxygenFinancier === 20)){
        res = await sendAODF2NOKOTP(payload);
      }

      console.log("res", res);
      if(res.status === true) {
      customAlert.showToast("success", "OTP sent successfully, please check your next of kin phone for OTP"); 
      } else {
      customAlert.showToast("error", `${res?.message}` || "Failed to send next of kin OTP");
      }
    }

    const handleProceed = async(otp) =>{
      dispatch(setOtpLoading(true));
        // OTP Validation:
        const res = await validateNokOtp(otp, customerDetails?.next_Kin_Msisdn, storePrecustomer.precustomer?.precustomerId );

        if(res.status === true) {
        dispatch(setOtpLoading(false));
        // Update precustomer in store
        setTimeout(async () => {
          if (
            dispatch(
              updatePrecustomer({
                ...storePrecustomer,
                onboarding_status: "sideload",
              })
            )
          ) {
            customAlert.showToast("success", `${res?.message}`||"Next of kin OTP validated successfully");
            // if it's not for oxygen, redirect to  sideloading
            if (savedOxygenFinancier !== 14 || Number(partnerId) !== 408 || financierName !== "Oxygen"){
              // Make api call to update the onboarding status since device reg is successful
              await updateCustomerOnboardingStat(
                storePrecustomer?.precustomer?.msisdn,
                "KYC_APPROVED"
              );
              
              // Redirect to sideloading
              navigate("/sideload");
            }else{
              setOtpValidated(true);
            }
          }
        }, [2000]);

        }else{
          dispatch(setOtpLoading(false));
          // Make api call to update the onboarding status since device reg is successful
          await updateCustomerOnboardingStat(
            storePrecustomer?.precustomer?.msisdn,
            "KYC_SUBMITTED"
          );
        customAlert.showToast("error", `${res?.message}` || "Failed to validate next of kin OTP");
        }
    
    }
    
    const handleAODF2Proceed = async(otp) => {
      dispatch(setOtpLoading(true));
      const payload= {
        otp: String(otp),
        msisdn: String(customerDetails?.next_Kin_Msisdn),
        preCustomerId: Number(storePrecustomer.precustomer?.precustomerId)
      }
        // OTP Validation:
        const res = await validateAODF2NOKOTP(payload); 
        console.log("res", res);
        if(res.status === true) {
          dispatch(
            updatePrecustomer({
              ...storePrecustomer,
              onboarding_status: "sideload",
            })
          );

          // Make api call to update the onboarding status since device reg is successful
          await updateCustomerOnboardingStat(
            storePrecustomer?.precustomer?.msisdn,
            "KYC_APPROVED"
          );
          customAlert.showToast("success", `${res?.message}`||"Next of kin OTP validated successfully");
          
          // Redirect to sideloading
          navigate("/sideload");
        }else{
          // Make api call to update the onboarding status since device reg is successful
          await updateCustomerOnboardingStat(
            storePrecustomer?.precustomer?.msisdn,
            "KYC_SUBMITTED"
          );
          customAlert.showToast("error", `${res?.message}` || "Failed to validate next of kin OTP");
        }
        dispatch(setOtpLoading(false));
    }

    const actions = {handleResendOTP:handleResendNOKOTP , handleProceed: Number(savedOxygenFinancier === 20) ? handleAODF2Proceed : handleProceed, 
      title: "An OTP was sent to your next of kin phone number, kindly request for it and input it in the field below.",
    }

  return (
    <div>
      <OxygenOTPComponent {...actions}  />
    </div>
  )
}

export default NextOfKinOTP